"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuditClient = void 0;
const BaseClient_1 = require("../BaseClient");
class AuditClient extends BaseClient_1.BaseClient {
    constructor(baseUrl, tokenProvider) {
        super(baseUrl, tokenProvider);
    }
    async list(request) {
        const response = await this.axiosInstance({
            method: 'POST',
            url: '/api/v1/audit/list',
            data: request,
        });
        return response.data;
    }
    async get(request) {
        const response = await this.axiosInstance({
            method: 'GET',
            url: '/api/v1/audit/get',
            params: {
                id: request.id,
            },
        });
        return response.data;
    }
}
exports.AuditClient = AuditClient;
